import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface OtherAmountProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const OtherAmount: React.FC<OtherAmountProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [otherAmount, set_otherAmount] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Final Structure']?.['Other Work']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Final Structure': { ...b.values?.['Final Structure'], 'Other Work': [b.values?.['Final Structure']?.['Other Work']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Other - Amount';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(otherAmount)}
                />
            ) : (
                <MoneyBox
                    id={'otherAmount-finalStructure'}
                    allowNegative={false}
                    value={otherAmount}
                    onChange={(value) => set_otherAmount(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
